<script setup lang="ts">
import { computed, PropType } from "vue";
import Avatar from "primevue/avatar";

// Minimal structural shape so any app's Trainer/account object satisfies it
// without the component depending on the app's full Trainer type.
interface AvatarPerson {
    firstname?: string;
    lastname?: string;
    portrait?: string;
}

const props = defineProps({
    trainer: {
        type: Object as PropType<AvatarPerson | null>,
        default: null,
    },
    imageUrl: {
        type: String,
        default: "",
    },
    size: {
        type: String as PropType<"normal" | "large" | "xlarge">,
        default: "normal",
    },
    title: {
        type: String,
        default: "",
    },
    png: {
        type: Boolean,
        default: false,
    },
});

const actualSize = computed(() => {
    switch (props.size) {
        case "xlarge":
            return "4rem";
        case "large":
            return "3rem";
        default:
            return "2rem";
    }
});

const pngSrc = computed(() => props.imageUrl || props.trainer?.portrait || "");

function buildInitials() {
    const first = props.trainer?.firstname?.substring(0, 1) || "X";
    const last = props.trainer?.lastname?.substring(0, 1) || "X";
    return `${first}${last}`;
}
</script>

<template>
    <Avatar v-if="imageUrl && !png" :image="imageUrl" style="background: transparent" :size="size" shape="circle" />
    <img
        v-else-if="pngSrc && png"
        :src="pngSrc"
        :alt="buildInitials()"
        class="p-avatar-image"
        :style="`width: ${actualSize}; height: ${actualSize}; border-radius: 50%`"
    />
    <Avatar v-else :label="buildInitials()" class="bg-brand text-white" :size="size" shape="circle" />
    <span v-if="title != ''" class="mt-2">{{ title }}</span>
</template>
